/**
 * @generated SignedSource<<7729a0cdf56101aa6bfa35cb01936e34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type dividendsPage_Query$variables = Record<PropertyKey, never>;
export type dividendsPage_Query$data = {
  readonly dividends: {
    readonly candidates: ReadonlyArray<{
      readonly row: {
        readonly accountNumber: string | null | undefined;
        readonly amount: number;
        readonly classification: TxnClassificationEnum | null | undefined;
        readonly counterparty: {
          readonly name: string;
        } | null | undefined;
        readonly description: string;
        readonly md5: string;
        readonly postingDate: string;
        readonly txn: {
          readonly id: string;
        };
      };
      readonly shareholder: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    }>;
    readonly counterparties: ReadonlyArray<{
      readonly cxid: string;
      readonly id: string;
      readonly name: string;
    }>;
    readonly epochs: ReadonlyArray<{
      readonly balanced: boolean;
      readonly effectiveDate: any;
      readonly holdings: ReadonlyArray<{
        readonly basisPoints: number;
        readonly explicit: boolean;
        readonly shareholder: {
          readonly id: string;
          readonly name: string;
        };
      }>;
      readonly totalBps: number;
    }>;
    readonly paidTotalCents: number;
    readonly periods: ReadonlyArray<{
      readonly balanced: boolean;
      readonly declaredTotalCents: number | null | undefined;
      readonly endDate: any;
      readonly firstPaymentDate: any;
      readonly lastPaymentDate: any;
      readonly lines: ReadonlyArray<{
        readonly actualBps: number;
        readonly basisPoints: number | null | undefined;
        readonly entitledCents: number;
        readonly matched: boolean;
        readonly paidCents: number;
        readonly shareholder: {
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly varianceCents: number;
      }>;
      readonly paidTotalCents: number;
      readonly paymentCount: number;
      readonly payments: ReadonlyArray<{
        readonly assigned: boolean;
        readonly cents: number;
        readonly derivedPeriod: string;
        readonly period: string;
        readonly row: {
          readonly accountNumber: string | null | undefined;
          readonly amount: number;
          readonly classification: TxnClassificationEnum | null | undefined;
          readonly counterparty: {
            readonly name: string;
          } | null | undefined;
          readonly description: string;
          readonly md5: string;
          readonly postingDate: string;
          readonly txn: {
            readonly id: string;
          };
        };
        readonly shareholder: {
          readonly id: string;
          readonly name: string;
        } | null | undefined;
      }>;
      readonly period: string;
      readonly reconciled: boolean;
      readonly startDate: any;
      readonly totalBps: number;
      readonly totalCents: number;
      readonly unaccountedCents: number;
      readonly unknownCents: number;
    }>;
    readonly shareholders: ReadonlyArray<{
      readonly currentBasisPoints: number | null | undefined;
      readonly handle: string;
      readonly holdings: ReadonlyArray<{
        readonly basisPoints: number;
        readonly effectiveDate: any;
        readonly id: string;
        readonly note: string | null | undefined;
      }>;
      readonly id: string;
      readonly name: string;
      readonly notes: string | null | undefined;
      readonly ordinal: number;
      readonly stakeholder: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly stakeholderCxid: string | null | undefined;
    }>;
    readonly totalCents: number;
    readonly unreconciledCount: number;
  };
};
export type dividendsPage_Query = {
  response: dividendsPage_Query$data;
  variables: dividendsPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCents",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paidTotalCents",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreconciledCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "counterparties",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cxid",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveDate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "basisPoints",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Shareholder",
  "kind": "LinkedField",
  "name": "shareholders",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "handle",
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ordinal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stakeholderCxid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentBasisPoints",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Stakeholder",
      "kind": "LinkedField",
      "name": "stakeholder",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Shareholding",
      "kind": "LinkedField",
      "name": "holdings",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "note",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalBps",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balanced",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "explicit",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Shareholder",
  "kind": "LinkedField",
  "name": "shareholder",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "period",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "declaredTotalCents",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unaccountedCents",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentCount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstPaymentDate",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastPaymentDate",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unknownCents",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reconciled",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entitledCents",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paidCents",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "varianceCents",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualBps",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "matched",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cents",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "derivedPeriod",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assigned",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Txn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "md5",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postingDate",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "classification",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "TransactionRow",
  "kind": "LinkedField",
  "name": "row",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Stakeholder",
      "kind": "LinkedField",
      "name": "counterparty",
      "plural": false,
      "selections": [
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "TransactionRow",
  "kind": "LinkedField",
  "name": "row",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Stakeholder",
      "kind": "LinkedField",
      "name": "counterparty",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "dividendsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Dividends",
        "kind": "LinkedField",
        "name": "dividends",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v5/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CapTableEpoch",
            "kind": "LinkedField",
            "name": "epochs",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CapTableHolding",
                "kind": "LinkedField",
                "name": "holdings",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DividendPeriod",
            "kind": "LinkedField",
            "name": "periods",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v0/*: any*/),
              (v1/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DividendLine",
                "kind": "LinkedField",
                "name": "lines",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DividendPayment",
                "kind": "LinkedField",
                "name": "payments",
                "plural": true,
                "selections": [
                  (v29/*: any*/),
                  (v14/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v13/*: any*/),
                  (v39/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DividendCandidate",
            "kind": "LinkedField",
            "name": "candidates",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v39/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "dividendsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Dividends",
        "kind": "LinkedField",
        "name": "dividends",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v5/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CapTableEpoch",
            "kind": "LinkedField",
            "name": "epochs",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CapTableHolding",
                "kind": "LinkedField",
                "name": "holdings",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DividendPeriod",
            "kind": "LinkedField",
            "name": "periods",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v0/*: any*/),
              (v1/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DividendLine",
                "kind": "LinkedField",
                "name": "lines",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v13/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DividendPayment",
                "kind": "LinkedField",
                "name": "payments",
                "plural": true,
                "selections": [
                  (v29/*: any*/),
                  (v14/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v13/*: any*/),
                  (v40/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DividendCandidate",
            "kind": "LinkedField",
            "name": "candidates",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v40/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "82aff22114e5fe75f53e017153ee7738",
    "id": null,
    "metadata": {},
    "name": "dividendsPage_Query",
    "operationKind": "query",
    "text": "query dividendsPage_Query {\n  dividends {\n    totalCents\n    paidTotalCents\n    unreconciledCount\n    counterparties {\n      id\n      cxid\n      name\n    }\n    shareholders {\n      id\n      handle\n      name\n      ordinal\n      notes\n      stakeholderCxid\n      currentBasisPoints\n      stakeholder {\n        id\n        name\n      }\n      holdings {\n        id\n        effectiveDate\n        basisPoints\n        note\n      }\n    }\n    epochs {\n      effectiveDate\n      totalBps\n      balanced\n      holdings {\n        basisPoints\n        explicit\n        shareholder {\n          id\n          name\n        }\n        id\n      }\n      id\n    }\n    periods {\n      period\n      startDate\n      endDate\n      totalCents\n      paidTotalCents\n      declaredTotalCents\n      unaccountedCents\n      paymentCount\n      firstPaymentDate\n      lastPaymentDate\n      totalBps\n      balanced\n      unknownCents\n      reconciled\n      lines {\n        basisPoints\n        entitledCents\n        paidCents\n        varianceCents\n        actualBps\n        matched\n        shareholder {\n          id\n          name\n        }\n        id\n      }\n      payments {\n        cents\n        period\n        derivedPeriod\n        assigned\n        shareholder {\n          id\n          name\n        }\n        row {\n          txn {\n            id\n          }\n          md5\n          postingDate\n          description\n          amount\n          accountNumber\n          classification\n          counterparty {\n            name\n            id\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n    candidates {\n      shareholder {\n        id\n        name\n      }\n      row {\n        txn {\n          id\n        }\n        md5\n        postingDate\n        description\n        amount\n        accountNumber\n        classification\n        counterparty {\n          name\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "78665a2e5aaad3387a97dec7c7f77df8";

export default node;
